<template>
  <v-card class="documents-toolbar-card mb-4 px-4 py-3" outlined>
    <div class="documents-toolbar-row d-flex align-center flex-wrap flex-md-nowrap">
      <!-- Expand / Collapse All buttons (for master brokers, far left) -->
      <div v-if="isBroker" class="d-flex align-center flex-shrink-0 mr-3 mb-2 mb-md-0">
        <v-btn
          color="primary"
          small
          outlined
          class="mr-2 text-capitalize expand-btn"
          data-testid="documents-expand-all"
          @click="$emit('expand-all')"
        >
          <span class="white--text">{{ $t('instructions.expandAll') }}</span>
        </v-btn>
        <v-btn
          color="primary"
          small
          outlined
          class="text-capitalize expand-btn"
          data-testid="documents-collapse-all"
          @click="$emit('collapse-all')"
        >
          <span class="white--text">{{ $t('instructions.contractAll') }}</span>
        </v-btn>
      </div>

      <!-- Search input (flexible shrink/grow) -->
      <div class="search-container flex-grow-1 flex-shrink-1 mr-3 mb-2 mb-md-0" data-testid="documents-search">
        <v-text-field
          :value="search"
          :placeholder="$t('documents.searchLabel')"
          prepend-inner-icon="mdi-magnify"
          dense
          outlined
          clearable
          hide-details
          class="documents-search-input"
          @input="$emit('update:search', $event || '')"
        />
      </div>

      <!-- Segmented filter pills -->
      <div class="filter-container flex-shrink-0 mr-3 mb-2 mb-md-0">
        <v-btn-toggle
          :value="filterMode"
          mandatory
          dense
          class="documents-filter-toggle"
          @change="$emit('update:filterMode', $event)"
        >
          <v-btn value="all" small class="text-capitalize filter-pill">
            {{ $t('documents.filterAll') }}
            <v-chip v-if="counts.total !== undefined" x-small class="ml-1 count-chip">
              {{ counts.total }}
            </v-chip>
          </v-btn>

          <v-btn value="with_docs" small class="text-capitalize filter-pill">
            {{ $t('documents.filterWithDocs') }}
            <v-chip v-if="counts.withDocs !== undefined" x-small class="ml-1 count-chip" color="primaryTransp" text-color="primary">
              {{ counts.withDocs }}
            </v-chip>
          </v-btn>

          <v-btn value="missing_docs" small class="text-capitalize filter-pill" data-testid="documents-filter-missing-docs">
            {{ $t('documents.filterMissingDocs') }}
            <v-chip v-if="counts.missingDocs !== undefined" x-small class="ml-1 count-chip" color="yellowTransp" text-color="orangeColor">
              {{ counts.missingDocs }}
            </v-chip>
          </v-btn>
        </v-btn-toggle>
      </div>

      <!-- Refresh action (far right) -->
      <div class="refresh-container flex-shrink-0 ml-auto">
        <v-btn
          small
          outlined
          color="primary"
          class="refresh-btn text-capitalize"
          :loading="loading"
          :disabled="loading"
          data-testid="documents-refresh"
          @click="$emit('refresh')"
        >
          <v-icon small left>mdi-refresh</v-icon>
          {{ $t('documents.refresh') }}
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'DocumentsToolbar',

  props: {
    search:        { type: String, default: '' },
    filterMode:    { type: String, default: 'all' },
    counts:        { type: Object, default: () => ({ total: 0, withDocs: 0, missingDocs: 0 }) },
    totalCount:    { type: Number, default: 0 },
    filteredCount: { type: Number, default: 0 },
    loading:       { type: Boolean, default: false },
    isBroker:      { type: Boolean, default: false },
  },

  emits: ['update:search', 'update:filterMode', 'refresh', 'expand-all', 'collapse-all'],
}
</script>

<style scoped lang="scss">
.documents-toolbar-card {
  background: #1e1e1e !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 12px !important;
}

.search-container {
  min-width: 170px;
  max-width: 380px;
}

.documents-search-input {
  ::v-deep .v-input__slot {
    background: rgba(0, 0, 0, 0.3) !important;
    border-radius: 8px !important;
  }
}

.documents-filter-toggle {
  background: rgba(0, 0, 0, 0.4) !important;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px !important;
  padding: 2px;

  .v-btn {
    background: transparent !important;
    border: none !important;
    border-radius: 6px !important;
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 11px !important;
    font-weight: 500;
    letter-spacing: 0.02em;
    min-height: 28px;
    padding: 0 10px !important;

    &.v-btn--active {
      background: rgba(255, 255, 255, 0.12) !important;
      color: #ffffff !important;
      font-weight: 600;
    }
  }
}

.count-chip {
  font-size: 10px !important;
  height: 16px !important;
  padding: 0 5px !important;
}

.refresh-btn {
  border-color: rgba(0, 115, 255, 0.4) !important;
  border-radius: 8px !important;
  font-size: 11px !important;
  font-weight: 600;

  &:hover {
    background: rgba(0, 115, 255, 0.1) !important;
    border-color: #0073ff !important;
  }
}
</style>
